<div class="wrap" #openMode="cdkOverlayOrigin" cdkOverlayOrigin>
    <div *ngIf="filesSig$().length === 0 else existFiles">
        <div class="upload-card" queDrag (FilesEvent)="filesDroped($event)">

            <que-document-camera *ngIf="isUser" (fileCaptured)="addCapturedFile($event)"></que-document-camera>

            <div class="divider" *ngIf="isUser">
                <span translate>questionBoard.edit.uploadFile.or</span>
            </div>

            <div class="upload-link pointer" (click)="fileInput.click()">
                <svg-icon class="upload-icon" src="/assets/images/display-question/upload.svg"></svg-icon>
                <span class="upload-text" translate>questionBoard.edit.uploadFile.clickOrDragFileToUpload</span>
                <input #fileInput accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                    class="display-none" type="file" multiple [disabled]="!getCanUpload()"
                    (change)="onFileChange(fileInput)" />
            </div>
        </div>
    </div>

    <ng-template #existFiles>
        <div class="wrap-count-files pointer" [class.open]="isOpen" (click)="isOpen = true">
            <div class="right">
                <div class="img">
                    <svg-icon class="icon" src="/assets/images/description.svg"></svg-icon>
                </div>
                <p>{{filesSig$().length +" " + ('questionBoard.edit.uploadFile.files' | translate)}}</p>
            </div>
            <svg-icon class="icon left" [class.rotated]="isOpen" src="/assets/images/arrow-down.svg"></svg-icon>
        </div>
    </ng-template>
</div>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="openMode" [cdkConnectedOverlayHasBackdrop]="true"
    (backdropClick)="isOpen = false" [cdkConnectedOverlayOpen]="isOpen"
    cdkConnectedOverlayBackdropClass="backdrop-selection" [cdkConnectedOverlayPositions]="positonArea"
    [cdkConnectedOverlayWidth]="openMode.elementRef.nativeElement.getBoundingClientRect().width">
    <ng-container>
        <div class="wrap exist-files">
            <div *ngIf="getCanUpload()">
                <div class="upload-card upload-card--compact" queDrag (FilesEvent)="filesDroped($event)">
                    <que-document-camera *ngIf="isUser" (fileCaptured)="addCapturedFile($event)"></que-document-camera>
                    <div class="divider" *ngIf="isUser">
                        <span translate>questionBoard.edit.uploadFile.or</span>
                    </div>
                    <div class="upload-link pointer" (click)="fileInput.click()">
                        <svg-icon class="upload-icon" src="/assets/images/display-question/upload.svg"></svg-icon>
                        <span class="upload-text" translate>questionBoard.edit.uploadFile.clickOrDragFileToUpload</span>
                        <input #fileInput accept="image/*,.pdf" class="display-none" type="file" multiple
                            [disabled]="!getCanUpload()" (change)="onFileChange(fileInput)" />
                    </div>
                </div>
            </div>

            <div *ngIf="filesSig$().length" class="files-list">
                <div class="file" *ngFor="let file of filesSig$() let i = index">
                    <div class="right">
                        <svg-icon class="icon" src="/assets/images/description.svg"></svg-icon>
                        <p class="file-name">{{ shortFileName(file.fileName) }}</p>
                    </div>
                    <div class="left">
                        <button type="button" class="icon-btn" (click)="previewFile(file)">
                            <svg-icon svgClass="svg-img" class="icon" src="/assets/images/preview-eye.svg"></svg-icon>
                        </button>
                        <button type="button" class="icon-btn delete" (click)="remove(i)">
                            <svg-icon svgClass="delete" class="icon" src="/assets/images/question-menu/delete.svg"></svg-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</ng-template>
